import React from 'react';
import './VideoSection.css';
import videoProject from '../assets/video/Video Project 4-1(1).m4v';

function VideoSection() {
    return (
        <section className="video-section">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <div className="video-container">
                            <video autoPlay loop muted className="video-player">
                                <source src={videoProject} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <div className="video-content">
                            <h2>Experience JDS Hospital Excellence</h2>
                            <p>Watch our comprehensive video showcasing our state-of-the-art facilities, expert medical team, and commitment to patient care. Discover how we combine advanced technology with compassionate healthcare to deliver exceptional medical services.</p>
                            <p>From emergency care to specialized treatments, our hospital is equipped to handle all your healthcare needs with the highest standards of medical excellence.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default VideoSection;
